'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Registration = undefined;

var _Registration2 = require('./Registration');

var _Registration3 = _interopRequireDefault(_Registration2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Registration = _Registration3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Registration/index.js
// module id = 1844
// module chunks = 0